import React from 'react';
import { useIntl } from 'react-intl';
import { KTIcon, enumPolicies } from '../../../_metronic/helpers';
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker';
import { XYGraphWidget } from '../../../_metronic/partials/widgets';

const OrderStatisticsCard = ({ ordersMetric, loading }) => {
    const intl = useIntl();

    if (loading || !ordersMetric) {
        return (
            <div className='card mb-5 mb-xl-8'>
                <div className='card-body d-flex justify-content-center align-items-center' style={{ minHeight: '300px' }}>
                    <span className="spinner-border text-primary" role="status"></span>
                    <span className="text-gray-800 fs-6 fw-semibold ms-3">{intl.formatMessage({ id: 'GENERAL.LOADING' })}</span>
                </div>
            </div>
        );
    }

    // Helper to render a card without graph
    const MetricCard = ({ icon, iconColor, value, label }) => (
        <div className="card h-100 border border-gray-300 border-dashed rounded p-4">
            <div className="d-flex align-items-center">
                <div className="symbol symbol-40px me-3">
                    <span className={`symbol-label bg-light-${iconColor}`}>
                        <KTIcon iconName={icon} className={`fs-2 text-${iconColor}`} />
                    </span>
                </div>
                <div className="d-flex flex-column">
                    <span className="fs-4 text-gray-800 fw-bolder">
                        {value}
                    </span>
                    <span className="fs-7 text-muted fw-bold">{label}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="card">
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold fs-3 mb-1">
                        {intl.formatMessage({ id: 'ORDERS.METRICS.HEADER' })}
                    </span>
                </h3>
            </div>
            <div className="card-body p-9">
                <div className="row g-5 g-xl-8">
                    <div className="col-md-6 col-lg-3">
                        <MetricCard
                            icon="calendar-8"
                            iconColor="success"
                            value={ordersMetric.todayOrderCount}
                            label={intl.formatMessage({ id: 'ORDERS.METRICS.TODAY' }) + ' ' + intl.formatMessage({ id: 'ORDERS.METRIC.COUNT' })}
                        />
                    </div>
                    
                    <PolicyChecker policies={[enumPolicies.OrderDealer, enumPolicies.OrderAdmin]}>
                        <div className="col-md-6 col-lg-3">
                            <MetricCard
                                icon="dollar"
                                iconColor="primary"
                                value={intl.formatNumber(ordersMetric.todayTotalPrice, { style: 'currency', currency: 'EUR' })}
                                label={intl.formatMessage({ id: 'ORDERS.METRICS.TODAY' }) + ' ' + intl.formatMessage({ id: 'ORDERS.METRIC.PRICE' })}
                            />
                        </div>
                    </PolicyChecker>

                    <div className="col-md-6 col-lg-3">
                        <MetricCard
                            icon="abstract-38"
                            iconColor="success"
                            value={ordersMetric.orderCount}
                            label={intl.formatMessage({ id: 'ORDERS.METRICS.14_DAYS' }) + ' ' + intl.formatMessage({ id: 'ORDERS.METRIC.COUNT' })}
                        />
                    </div>

                    <PolicyChecker policies={[enumPolicies.OrderDealer, enumPolicies.OrderAdmin]}>
                        <div className="col-md-6 col-lg-3">
                            <MetricCard
                                icon="finance-calculator"
                                iconColor="primary"
                                value={intl.formatNumber(ordersMetric.totalPrice, { style: 'currency', currency: 'EUR' })}
                                label={intl.formatMessage({ id: 'ORDERS.METRICS.14_DAYS' }) + ' ' + intl.formatMessage({ id: 'ORDERS.METRIC.PRICE' })}
                            />
                        </div>
                    </PolicyChecker>
                </div>

                <div className="row g-5 g-xl-8 mt-5">
                    <div className="col-md-12">
                        {
                            ordersMetric && ordersMetric?.dateBasedOrder?.length > 0 && 
                            <XYGraphWidget 
                                name={intl.formatMessage({ id: 'ORDERS.METRIC.DATEBASED_ORDERS' })} 
                                chartData={ordersMetric.dateBasedOrder} 
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderStatisticsCard;
